import React from 'react'

export function BplStatCardsSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="h-20 rounded-lg border bg-card animate-pulse bg-muted/40" />
      ))}
    </div>
  )
}

export function BplTableSkeleton({ rows = 8 }) {
  return (
    <div className="border rounded-lg bg-card overflow-hidden">
      <div className="h-10 bg-navy/80 animate-pulse" />
      <div className="divide-y">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="h-10 bg-muted/30 animate-pulse" style={{ animationDelay: `${i * 40}ms` }} />
        ))}
      </div>
    </div>
  )
}

export function BplLogListSkeleton({ rows = 6 }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-14 rounded-lg border bg-card animate-pulse bg-muted/30" />
      ))}
    </div>
  )
}

export function BplUpdatingBanner({ message }) {
  if (!message) return null
  return (
    <p className="text-xs text-muted-foreground flex items-center gap-2">
      <span className="w-3 h-3 border-2 border-muted border-t-primary rounded-full animate-spin shrink-0" />
      {message}
    </p>
  )
}
